import React, { FunctionComponent } from 'react';
import styles from './accordion.module.scss';
import {
  AccordionItem,
  IAccordionItemProps
} from './accordion-item/accordion-item';

export interface IAccordionProps {
  accordionItems: IAccordionItemProps[];
}

export const Accordion: FunctionComponent<IAccordionProps> = ({
  accordionItems
}) => {
  return (
    <div className={styles.container}>
      {accordionItems.map((item: IAccordionItemProps, i) => (
        <AccordionItem {...item} key={i} />
      ))}
    </div>
  );
};
